"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coachMessagesTypeSchema = exports.FALLBACK_COACH_MESSAGE_CATEGORIES = exports.coachMessageCategories = exports.coachMessageCategoriesWithPayload = void 0;
var zod_1 = __importDefault(require("zod"));
var coachMessageVariant = zod_1.default.object({
    name: zod_1.default.string(),
    audioUrl: zod_1.default.string().optional(),
    removePreviousMessages: zod_1.default.boolean().optional(),
});
exports.coachMessageCategoriesWithPayload = [
    'INCOMING_MEETING',
    'INCOMING_MEETING_IN_1',
    'INCOMING_MEETING_IN_2',
    'INCOMING_MEETING_IN_3',
    'INCOMING_MEETING_IN_4',
    'INCOMING_MEETING_IN_5',
    'INCOMING_MEETING_IN_10',
    'INCOMING_MEETING_IN_15',
];
exports.coachMessageCategories = __spreadArray(__spreadArray([], exports.coachMessageCategoriesWithPayload, true), [
    'BREAK',
    'BREAK_FOLLOW_UP',
    'COMPLETED',
    'COMPLETED_AHEAD_OF_SCHEDULE',
    'COMPLETED_CODING_SESSION',
    'COMPLETED_DESIGN_SESSION',
    'CONTINUE_FLOW',
    'ENCOURAGEMENT',
    'END_OF_SESSION',
    'URL_SHARED',
    'BUDDY_SESSION_URL_SHARED',
    'END_OF_BREAK',
    'END_OF_FLOW',
    'FIRST_BREAK',
    'FIRST_FLOW',
    'FLOW',
    'HALFWAY',
    'MARK_AS_DISTRACTION',
    'MARK_AS_PRODUCTIVE',
    'OVER_SCHEDULED_TIME',
    'PRODUCTIVITY_SCORE',
    'PRODUCTIVITY_SCORE_LOW',
    'PRODUCTIVITY_SCORE_MEDIUM',
    'PRODUCTIVITY_SCORE_HIGH',
    'PRODUCTIVITY_SCORE_APP_TRACKING',
    'PRODUCTIVITY_SCORE_DND',
    'REMAINING_1',
    'REMAINING_2',
    'REMAINING_5',
    'REMAINING_10',
    'DESKTOP_DISTRACTION',
    'IDLE_MESSAGES',
    'PHONE_DISTRACTION',
    'COMPLETED_EMAIL_SESSION',
    'COMPLETED_STUDY_SESSION',
    'COMPLETED_WRITING_SESSION',
], false);
/**
 * These are coach messages that we don't yet have across ALL coaches.
 */
var OPTIONAL_COACH_MESSAGE_CATEGORIES = [
    'FIRST_BREAK',
    'PHONE_DISTRACTION',
    'ENCOURAGEMENT',
    'END_OF_SESSION',
    'PRODUCTIVITY_SCORE',
    'PRODUCTIVITY_SCORE_LOW',
    'PRODUCTIVITY_SCORE_MEDIUM',
    'PRODUCTIVITY_SCORE_HIGH',
    'PRODUCTIVITY_SCORE_APP_TRACKING',
    'PRODUCTIVITY_SCORE_DND',
    'BUDDY_SESSION_URL_SHARED',
    'COMPLETED_EMAIL_SESSION',
    'COMPLETED_STUDY_SESSION',
    'COMPLETED_WRITING_SESSION',
];
exports.FALLBACK_COACH_MESSAGE_CATEGORIES = {
    COMPLETED_CODING_SESSION: 'END_OF_SESSION',
    COMPLETED_WRITING_SESSION: 'END_OF_SESSION',
    COMPLETED_EMAIL_SESSION: 'END_OF_SESSION',
};
exports.coachMessagesTypeSchema = zod_1.default.object(Object.fromEntries(exports.coachMessageCategories.map(function (category) {
    var categoryType = OPTIONAL_COACH_MESSAGE_CATEGORIES.includes(category)
        ? zod_1.default.array(coachMessageVariant).optional()
        : zod_1.default.array(coachMessageVariant).min(1);
    return [category, categoryType];
})));
